import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "template"]
  static values = { index: Number }

  add() {
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.indexValue++
  }

  remove(event) {
    const row = event.target.closest("[data-quiz-choices-row]")
    const destroyInput = row.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
  }
}
